import React, { useState, useEffect } from "react";
import DeliveryHead from "../delivery/DeliveryHead";
import DetailsHeader from "./DetailsHeader";
import { Grid, Container } from "@mui/material";
import DetailsMain from "./DetailsMain";
import BookingStatus from "./BookingStatus";
import { useSearchParams } from "react-router-dom";
import Loader from "../../shared/loader";
import { toast } from "react-hot-toast";
import { GetSingleOrder } from "../../../services/orders/Orders";
// import httpRequest from "../../../axios/index";
// import { ORDERS } from "../../../constants/apiEndPoints";

const OrderDetails = () => {
  const [showOnMobile, setShowOnMobile] = useState("OrderDetails");
  const [OrderData, SetOrderData] = useState([]);

  const [Loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const isMobile = window.innerWidth <= 768;
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setShowOnMobile("OrderDetails");
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleButtonClick = (buttonName) => {
    if (isMobile) {
      setShowOnMobile(buttonName);
    }
  };

  useEffect(() => {
    handleFetchOrders();
  }, [id]);

  const handleFetchOrders = async () => {
    await GetSingleOrder(id, setLoading, SetOrderData, toast);
  };

  return (
    <>
      <DeliveryHead
        Value={66}
        BackLink="/my-orders"
        CenterText="Details"
        StepText="2 of 3"
        showBox={false}
        showLink={true}
      />
      {Loading && <Loader />}

      {!Loading && (
        <DetailsHeader
          handleButtonClick={handleButtonClick}
          showOnMobile={showOnMobile}
        />
      )}
      {/* <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <DetailsMain />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <BookingStatus />
          </Grid>
        </Grid>
      </Container> */}
      {!Loading && (
        <Container maxWidth="lg">
          <Grid container spacing={3}>
            {isMobile && showOnMobile === "OrderDetails" && (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <DetailsMain OrderData={OrderData} />
              </Grid>
            )}
            {isMobile && showOnMobile === "BookingStatus" && (
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <BookingStatus OrderData={OrderData} />
              </Grid>
            )}
            {!isMobile && (
              <>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <DetailsMain OrderData={OrderData} />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <BookingStatus OrderData={OrderData} />
                </Grid>
              </>
            )}
          </Grid>
        </Container>
      )}
    </>
  );
};

export default OrderDetails;
